// src/components/OnlineParticipants.js
import React, { useEffect, useState } from 'react';
import './OnlineParticipants.css'; // Import the CSS file for styling
import RoulettePro from 'react-roulette-pro';
import 'react-roulette-pro/dist/index.css';
import Confetti from 'react-confetti';

const NamePicker = ({ participants = [], setWinner }) => {
	const [start, setStart] = useState(false);

	function getRandomOnlineIndex() {
		// Filter the array to get only online objects
		const onlineItems = participants.filter((item) => item.online === true);

		// Check if there are any online items
		if (onlineItems.length === 0) {
			const randomIndex = Math.floor(
				Math.random() *
					(participants.length - participants.length * 0.75 + 1) +
					participants.length * 0.75
			);

			return randomIndex;
		}

		// Generate a random index for the filtered array
		const randomIndex = Math.floor(
			Math.random() *
				(onlineItems.length - onlineItems.length * 0.75 + 1) +
				onlineItems.length * 0.75
		);

		// Find the corresponding index in the original array
		const originalIndex = participants.indexOf(onlineItems[randomIndex]);
		console.log(originalIndex);
		return originalIndex;
	}

	const handleStart = () => {
		setStart((prevState) => !prevState);
	};

	return (
		<>
			<RoulettePro
				start={start}
				spinningTime={10}
				prizes={participants}
				defaultDesignOptions={{
					prizesWithText: true
				}}
				options={{
					stopInCenter: true
				}}
				prizeIndex={getRandomOnlineIndex()}
				onPrizeDefined={setWinner}
			/>
			<div className="cntrbtn">
				<h5>Let's Spin the Randomiser to Find Out!</h5>
				<a className="btn cntrbtn" onClick={handleStart}>
					{start ? 'Reset' : 'Spin to win!'}
				</a>
			</div>
		</>
	);
};

export default NamePicker;
